import { combineReducers } from 'redux';
import addAsset from '~/domain/add-asset/store/add-asset-reducer';
import addAutomower from '~/domain/add-asset/store/add-robotic-mower-reducer';
import addMachine from '~/domain/add-asset/store/add-machine-reducer';
import addTagsDrawer from '~/components/containers/AddTagsDrawerContainer/reducer';
import app from '~/components/containers/AppContainer/reducer';
import areaDetails from '~/ducks/area-details/reducer';
import assetList from '~/domain/inventory-list/store/asset-list-reducer';
import roboticMowers from '~/domain/robotic-mowers/store/robotic-mowers-reducer';
import assetListFilter from '~/domain/inventory-list/store/asset-list-filters-reducer';
import assetMapAndDetails from '~/domain/asset-details-common/store/mapDetails/reducer';
import assetTags from '~/ducks/asset-tags/reducer';
import assetHfsOperations from '~/domain/assets/store/hfs-operations/reducer';
import assetsCounts from '~/domain/assets/store/assets-counts/reducer';
import assetHfsActions from '~/domain/assets/store/hfs-actions/reducer';
import assetTagRelationships from '~/ducks/asset-tag-relationships/reducer';
import accessGroupsAssets from '~/ducks/access-groups-assets/reducer';
import assetTypes from '~/ducks/asset-types/reducer';
import buySensor from '~/components/containers/BuySensorModalContainer/reducer';
import authentication from '~/ducks/authentication/reducer';
import map from '~/domain/maps/map-reducer';
import companyRequestedForDeletion from '~/components/containers/CompanyRequestedForDeletionContainer/reducer';
import companySettings from '~/domain/company/store/reducer';
import changeLog from '~/domain/changelog/store/reducer';
import changeMachineName from '~/components/containers/ChangeMachineNameContainer/reducer';
import dealerAccessV2 from '~/components/containers/DealerAccessContainerV2/reducer';
import dataExport from '~/components/containers/DataExportsContainer/combined-reducers';
import deleteMachine from '~/domain/asset-details-common/store/deleteMachine/reducer';
import deleteInvite from '~/components/containers/DeleteInviteContainer/reducer';
import deleteUser from '~/components/containers/DeleteUserContainer/reducer';
import editUser from '~/components/containers/EditUserContainer/reducer';
import expediteInviteRequests from '~/components/containers/ExpediteInviteRequestsContainer/reducer';
import editTagsDrawer from '~/components/containers/EditTagsDrawerContainer/reducer';
import editInviteRequest from '~/components/containers/EditInviteRequestContainer/reducer';
import featureActive from '~/ducks/feature-active/reducer';
import gateways from '~/components/containers/GatewaysContainer/reducer';
import infoModal from '~/components/containers/InfoModalContainer/reducer';
import inviteUser from '~/components/containers/InviteUserContainer/reducer';
import ISIMCodeValidator from '~/components/containers/ISIMCodeValidatorContainer/reducer';
import legalDocuments from '~/components/containers/LegalDocumentsContainer/reducer';
import machineFilterV2 from '~/ducks/machine-filter-v2/reducer';
import menu from '~/components/containers/MenubarContainer/reducer';
import productData from '~/ducks/product-data/reducer';
import serverMaintenance from '~/ducks/server-maintenance/reducer';
import roboticMowerScheduleV2 from '~/domain/roboticmower-details/store/schedule/reducer';
import placeIdResolver from '~/domain/assets/store/place-id-resolver/reducer';
import roboticMowerCommandErrors from '~/ducks/robotic-mower-command-errors/reducer';
import roboticMowerLoadingStates from '~/ducks/robotic-mower-loading-states/reducer';
import roboticSettingsStates from '~/domain/roboticmower-details/store/mowerCentricSettings/reducer';
import webViewSitemapSyncStates from '~/domain/roboticmower-details/store/mowerSitemapSyncStatus/reducer';
import roboticSecuritySettings from '~/domain/roboticmower-details/store/securitySettings/reducer';
import roboticInstallationSettingsStates from '~/domain/roboticmower-details/components/RoboticInstallationCard/reducer';
import assetTagsPatchPayloadStates from '~/domain/asset-details-common/components/TagCard/reducer';
import sendDeletionRequest from '~/components/containers/SendDeletionRequestContainer/reducer';
import setCuttingHeight from '~/components/containers/CuttingHeightManagement/reducer';
import technicalData from '~/ducks/technical-data/reducer';
import translation from '~/ducks/translations/reducer';
import unhandledError from '~/components/containers/UnhandledErrorContainer/reducer';
import userManagement from '~/components/containers/UserManagementContainer/reducer';
import userManagementSubmenu from '~/components/containers/UserManagementSubmenuContainer/reducer';
import userRoles from '~/ducks/user-roles/reducer';
import youtubePlaylist from '~/components/containers/YoutubePlaylistContainer/reducer';
import { bffWebApi } from '~/api';
import restartMachine from '~/domain/asset-details-common/store/restart/reducer';
import filterBar from '~/domain/inventory-list/store/filter-bar-reducer';
import filterBarV2 from '~/domain/inventory-list/store/filter-bar-v2-slice';
import native from '~/domain/native/store/reducer';
import cuttingHeightModal from '~/components/containers/CuttingHeightManagement/cutting-height-modal-reducer';
import cookieConsent from '~/domain/legal/store/cookie-consent-slice';
import greenkeeperLayerSettings from '~/domain/greenkeeper-tool/store/layer-settings-slice';
import remoteConfig from '~/config/firebase/remote-config-slice';
import assetTagsV2 from '~/domain/asset-details-common/components/TagCardV2/reducer';
import inventoryV2Selection from '~/domain/inventory-v2/store/inventory-v2-selection-slice';

const reducers = combineReducers({
  addAsset,
  addAutomower,
  addMachine,
  addTagsDrawer,
  app,
  areaDetails,
  assetList,
  assetMapAndDetails,
  assetListFilter,
  assetsCounts,
  assetTags,
  assetHfsActions,
  assetHfsOperations,
  assetTagRelationships,
  assetTagsPatchPayloadStates,
  accessGroupsAssets,
  assetTypes,
  authentication,
  buySensor,
  companyRequestedForDeletion,
  companySettings,
  changeLog,
  cookieConsent,
  changeMachineName,
  cuttingHeightModal,
  dealerAccessV2,
  dataExport,
  deleteMachine,
  deleteInvite,
  deleteUser,
  editTagsDrawer,
  editUser,
  expediteInviteRequests,
  editInviteRequest,
  featureActive,
  filterBar,
  filterBarV2,
  gateways,
  greenkeeperLayerSettings,
  infoModal,
  inventoryV2Selection,
  inviteUser,
  ISIMCodeValidator,
  legalDocuments,
  machineFilterV2,
  map,
  menu,
  native,
  placeIdResolver,
  productData,
  serverMaintenance,
  remoteConfig,
  restartMachine,
  roboticMowerCommandErrors,
  webViewSitemapSyncStates,
  roboticSecuritySettings,
  roboticMowerScheduleV2,
  roboticSettingsStates,
  roboticInstallationSettingsStates,
  roboticMowerLoadingStates,
  sendDeletionRequest,
  setCuttingHeight,
  roboticMowers,
  assetTagsV2,
  technicalData,
  translation,
  unhandledError,
  userManagement,
  userManagementSubmenu,
  userRoles,
  youtubePlaylist,
  // RTK Query
  [bffWebApi.reducerPath]: bffWebApi.reducer,
});

export type AppState = ReturnType<typeof reducers>;
export default reducers;
